import React from 'react';

const Footer = () => {
  return (
    <div>
        <div className='text-center text-dark p-3' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
            © 2025 Copyright: Asher's Door Services LLC
        </div>
    </div>
  )
}

export default Footer;